import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StatusButtonArchives = {
  statusButtonArchives: string;
  setStatusButtonArchives: (type: string) => void;
};

const useStatusButtonArchives = create(
  persist<StatusButtonArchives>(
    set =>
      ({
        statusButtonArchives: 'boards',
        setStatusButtonArchives: (type: string) =>
          set({ statusButtonArchives: type }),
      } as StatusButtonArchives),
    {
      name: '@tenGovUseStatusButtonArchives',
    },
  ),
);

export default useStatusButtonArchives;
